<template>
    <div>
        <!-- <no-data v-show="noDataShow" title='暂无气象站' ></no-data> -->
        <div class="pageTop">
            <div class='left'>                
                <p class='title'>{{baseName}}</p>                
            </div>
            <div class='right'>               
                <van-icon name="apps-o" color='#0076bf' size='22' @click="rListShow" style="vertical-align: middle;margin-left:15px"/>                
            </div>
        </div>
        <div  ref='pageMain'  style="overflow:auto;padding:0 5px">
            <van-panel style='margin:0 0 10px;' @click="weatgerStationDetails(item,index)"  v-for="(item,index) in weatherStationList" :key="index" :title="item.site_name" :desc="item.weather.record_time == '' ? '无': item.weather.record_time">
                <div>
                    <van-grid :column-num="2">
                        <van-grid-item    v-for="(data,i) in item.weather.name" :key="i">
                            <p style="font-size:10px;text-align: center;height:20px">{{item.weather.name[i]}}</p>
                            <br/>
                            <span style="color:#047cff;line-height:20px;font-size:14px">{{item.weather.weather[i]}}</span>
                        </van-grid-item>
                    </van-grid>
                </div>
            </van-panel>
            <van-divider  :style="{padding: '0 16px' }">
                    没有更多啦
            </van-divider>

        </div>

        
       
        



    </div>
</template>

<script>
import noData from '@/components/noData.vue'
import {mapMutations,mapState  } from "vuex";
import {getNodeWeatherStation} from '@/request/data'
export default {
    props:{
        uuid:{
            type:[String,Number],
            required: true
        },
        baseName:{
            type:String,
        }
    },
    components:{
        noData
    },
    data() {
        return {
            noDataShow:true,
            clientHeight:'',
            weatherStationList:[],
          
           
        }
    },
    computed: {        
            
    },
    mounted() {
        if (this.isBack) {
            
        }else{

        }
        // this.getWeatherName(0)
        this.getNodeWeatherStation()
        this.clientHeight =   `${document.documentElement.clientHeight}`
        window.onresize = function temp() {
            this.clientHeight = `${document.documentElement.clientHeight}`;
        };
        
        
    },
    watch: {
        clientHeight: function () {
            this.changeFixed(this.clientHeight)
        }
    },
    methods: {
        ...mapMutations(['setIsBcak','setBackIndex']),
        getNodeWeatherStation(){
            let data = {} 
            data.uuid = this.uuid
            getNodeWeatherStation(data).then(res=>{
                if(res.data.code == 0 && res.data.hasOwnProperty('data')){
                    if (res.data.data.length > 0) {
                        this.noDataShow = false
                         this.weatherStationList = []
                        for (let i = 0; i < res.data.data.length; i++) {
                            if (res.data.data[i].weather.type == 1 || !res.data.data[i].weather.hasOwnProperty('type') ) {
                                 this.weatherStationList.push(res.data.data[i])
                            }
                        }                        
                    }else{
                        this.noDataShow = true
                    }
                                      
                }else{
                    this.noDataShow = true
                }
            })
        },
        weatgerStationDetails(item,index){
            console.log(item)
            this.$router.push({name:'weatherCount',query:{uuid:item.uuid}})
            // this.stationInfo.name = item.site_name
            // this.stationInfo.uuid = item.uuid
            // this.stationInfo.type = item.type
            // this.fastAttribute = []
            // this.getStationWeatherInfo()
            // this.detailsPopup = true            
        },
        
        rListShow(){
            this.$emit('rListSon', 4);
        },
        changeFixed(clientHeight){//动态修改地图高度样式
            this.$nextTick(() => {
                this.$refs.pageMain.style.height = (clientHeight-134)+'px';
            })
        },
    },
}
</script>

<style  scoped>
.icon_noclick{ padding:3px;height: 26px;line-height: 26px;text-align: center;border-radius: 3px;border: 1px solid #ccc;background-color: #fff;margin: 5px;font-size: 12px;}
.icon_click{padding:3px;height: 26px;line-height: 26px;text-align: center;border-radius: 3px;border: 1px solid #0076bf;background-color: #0076bf;margin: 5px;font-size: 12px;color:#fff}

   


</style>